import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { Grid, Typography, Divider } from "@mui/material";
import "./infomodal.css";
import { getIcon } from "utils/iconsConfig";
import { formatInfoData } from "./formatInfoData";
import { capitalEachLetter } from "utils/capitalEachLetter";

const InfoModal = ({ open, setOpen, fetchData, setDetails = false, title }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  useEffect(() => {
    if (open) {
      (async () => {
        setLoading(true);
        setError(null);
        try {
          const result = await fetchData();
          setData(result?.data?.info || []);
        } catch (error) {
          setError("Failed to fetch details. Please try again.");
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [open]);

  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "400px", borderRadius: "12px", padding: "16px", background: "white" }}>
      {loading ? (
        <p>Loading...........</p>
      ) : (
        <>
          <Grid container spacing={2} className="info-data">
            {setDetails ? (
              <>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid">
                  <Typography variant="h6" fontWeight="600" fontFamily="Poppins">
                    Set Details
                  </Typography>
                  <Divider sx={{ backgroundColor: "#000", height: "1px", marginTop: 1 }} />
                </Grid>

                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="sub-grid">
                  {Object.entries(formatInfoData(data))
                    .slice(0, 2)
                    .map(([key, value]) => (
                      <Grid key={key} container alignItems="center" gap={1} className="main-div-sub-grid">
                        <Grid item className="icon-box">
                          {getIcon(key, "black")}
                        </Grid>
                        <Grid item>
                          <Typography className="sub-title" fontFamily="Poppins">
                            {value}
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                </Grid>
              </>
            ) : null}

            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Typography variant="h6" fontWeight="600" fontFamily="Poppins">
                {title}
              </Typography>
              <Divider sx={{ backgroundColor: "#000", height: "1px", marginTop: 1 }} />
            </Grid>

            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="metadata-section">
              {Object.entries(formatInfoData(data))
                .slice(2)
                .map(([key, value], index, array) => (
                  <React.Fragment>
                    <Grid key={key} container justifyContent="space-between" className="metadata-row">
                      <Grid item className="info-main-title">
                        {key}
                      </Grid>
                      <Grid item>
                        <Typography className="sub-title">
                          {capitalEachLetter(value)}
                        </Typography>
                      </Grid>
                    </Grid>
                    {index < array.length - 1 && <Divider sx={{ borderColor: "#aaa", height: "0.5px", marginY: 1 }} />}
                  </React.Fragment>
                ))}
            </Grid>
          </Grid>
        </>
      )}
    </Modal>
  );
};

export default InfoModal;
